/**
 * English translations for CreatingTournament screen - Payment flow
 */
export const creatingTournamentTranslations = {
  // Payment flow
  payment: {
    redirecting: 'Redirecting to payment...',
    processing: 'Processing payment...',
    sessionCreating: 'Creating payment session...',
  },

  // Error messages
  errors: {
    paymentSessionFailed: 'Failed to create payment session. Please try again.',
    tournamentCreationFailed: 'Failed to create tournament. Please try again.',
    networkError: 'Connection error. Please check your internet connection.',
    serverError: 'Server error. Please try again later.',
    invalidStake: 'Invalid stake amount.',
    duplicateSession: 'Payment session already exists.',
    generic: 'An error occurred. Please try again.',
  },

  // Actions
  actions: {
    retry: 'Retry',
    cancel: 'Cancel',
    payAndCreate: 'Pay & Create',
    create: 'Create',
  },

  // Accessibility
  a11y: {
    redirectingToPayment: 'Redirecting to payment page',
    paymentError: 'Payment error occurred',
    tournamentCreated: 'Tournament created successfully',
  },
};

export type CreatingTournamentTranslations = typeof creatingTournamentTranslations;
